import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VIcon,{staticClass:"archive",staticStyle:{"color":"orange","font-size":"22px !important"},attrs:{"small":""},on:{"click":function($event){$event.stopPropagation();return _vm.archiveItem()}}},[_vm._v(" mdi-archive-arrow-up ")])
}
var staticRenderFns = []

export { render, staticRenderFns }